/* global $:false */

export default class CookieBanner {
  static init () {
    Array.from($('[data-cookie-consent]')).map((el) =>
      new CookieBanner(el))
  }

  constructor (el) {
    this.el = $(el)
    if (this.cookieExists()) { return }
    this.el.show()
    this.findElements()
    this.setupBindings()
    this.autoHide()
  }

  findElements () {
    this.button = this.el.find('[data-cookie-consent-button]')
  }

  setupBindings () {
    this.button.click(event => {
      event.preventDefault()
      this.setCookie()
      this.el.hide()
    })
  }

  autoHide () {
    // Hide after one minute, so that Bukowskis wall mount monitors look nicer.
    setTimeout(() => {
      this.el.hide('slow')
    }
    , 60000)
  }

  cookieName () {
    return 'bukowskis.com.cookie_eu_consent'
  }

  cookieExists () {
    return document.cookie.indexOf(this.cookieName()) > -1
  }

  setCookie () {
    const date = new Date()
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000))
    const expires = '; expires=' + date.toGMTString()
    document.cookie = this.cookieName() + '=' + 1 + expires + '; path=/'
  }
}
